'use client'

import { Menu, Text, Button } from '@mantine/core'
import { useRouter, usePathname } from 'next/navigation'
import { useState, useTransition } from 'react'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa6'
import { IoEarth } from 'react-icons/io5'

const locales = [
  { label: 'English', value: 'en' },
  { label: 'Español', value: 'es' }
]

export function LanguageSelector({ logosSize }) {
  const router = useRouter()
  const pathname = usePathname()
  const [isPending, startTransition] = useTransition()

  const handleChange = (value: string | null) => {
    if (!value) return

    const segments = pathname.split('/')
    if (segments.length > 1 && locales.some((l) => l.value === segments[1])) {
      segments[1] = value
    } else {
      segments.splice(1, 0, value)
    }

    const newPath = segments.join('/')

    startTransition(() => {
      router.push(newPath)
    })
  }

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Menu openDelay={100} closeDelay={400} position="top-end" shadow="md" opened={isOpen} onOpen={() => setIsOpen(true)} onClose={() => setIsOpen(false)} withinPortal>
    
      <Menu.Target>
        <Button
          variant="transparent"
          h={logosSize}
          size='xs'
          pl={0}
          leftSection={<IoEarth color="white" />}
          rightSection={isOpen ? <FaChevronUp  color="white" size={12} /> : <FaChevronDown color="white"  size={12}  />}
        >
          <Text c="white" size={logosSize} fw={500}>
            {getCurrentLocaleLabel(pathname)}
          </Text>
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {locales.map((locale) => (
          <Menu.Item
            key={locale.value}
            onClick={() => handleChange(locale.value)}
            disabled={isPending}
          >
            {locale.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}

function getCurrentLocale(pathname: string) {
  const segment = pathname.split('/')[1]
  const match = locales.find((l) => l.value === segment)
  return match ? match.value : 'en'
}

function getCurrentLocaleLabel(pathname: string) {
  const code = getCurrentLocale(pathname)
  return locales.find((l) => l.value === code)?.label ?? 'English'
}
